export default {

  users: (state) => {
    return state.users;
  },
  user: (state) => {
    return state.user;
  },
  userOptions: (state) => {
    const userOptions = [];
    state.users.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.name,
      };
      userOptions.push(pushItem);
    }
    return userOptions;
  },

  dynamicPageContent: (state) => {
    return state.dynamicPageContent;
  },


  // Static Getters ---------------------------------------------------------------
  fieldsPlanOptions() {
    return [
      { value: "A", text: "Plan A" },
      { value: "B", text: "Plan B" },
      { value: "C", text: "Plan C" },
      { value: "D", text: "Plan D" },
    ];
  },

  categoryOptions() {
    return [
      { value: "دسته‌بندی محصولات", text: "دسته‌بندی محصولات" },
      { value: "دسته‌بندی مقالات", text: "دسته‌بندی مقالات" },
    ];
  },

  roleOptions() {
    return [
      { value: "مدیر کل", text: "مدیر کل" },
      { value: "مدیر داخلی", text: "مدیر داخلی" },
      { value: "ناظر محتوا", text: "ناظر " },
      { value: "پرسنل اداری", text: "پرسنل اداری" },
      { value: "کاربر عادی", text: "کاربر عادی" },
    ];
  },

  sbuOptions() {
    return [
      { value: "API", text: "واحد صنایع شیمیایی نفتی (API)" },
      { value: "CEE", text: "واحد صنایع کشاورزی پویا (CEE)" },
      { value: "CMD", text: "محصولات پتروشیمی (CMD)" },
      { value: "DFG", text: "محصولات پلاستیکی (DFG)" },
      { value: "DDE", text: "وابسته به نانوفناوری (DDE)" },
    ];
  },

  testInfo() {
    return [
      { id: 1 ,title: "آموزشی و پژوهشی", qty: "42", category: "دسته‌بندی مقالات" },
      { id: 2 ,title: "آرایشی و بهداشتی", qty: "12", category: "دسته‌بندی محصولات" },
      { id: 3 ,title: "مواد غذایی", qty: "32", category: "دسته‌بندی محصولات" },
      { id: 4 ,title: "اطلاعیه های سازمان", qty: "15", category: "دسته‌بندی مقالات" },
      { id: 5 ,title: "تکنولوژی و فناوری روز", qty: "22", category: "دسته‌بندی مقالات" },
    ];
  },

  testUsers() {
    return [
      { id: 1 ,name: "امیر احمدی", username: "admin", city: "تهران", role: "مدیر کل", status: 1},
      { id: 2 ,name: "سمیرا حسینی", username: "samira", city: "تهران", role: "مدیر داخلی", status: 1},
      { id: 3 ,name: "ابراهیم رزاقی", username: "eRazzaghi", city: "تبریز", role: "پرسنل اداری", status: 1},
      { id: 4 ,name: "زهرا معلمی", username: "ZMoalemi", city: "تهران", role: "پرسنل اداری", status: 0},
      { id: 5 ,name: "فاطمه اخترآبادی", username: "akhtarabadi", city: "زاهدان", role: "کاربر عادی", status: 1},
      { id: 6 ,name: "حسین ایرانی مفرد", username: "hIrani", city: "تهران", role: "کاربر عادی", status: 0},
      { id: 7 ,name: "سارینا یزدانی", username: "sarina", city: "قم", role: "کاربر عادی", status: 1},
    ];
  },

};
